import { getAllSupportReasonTags } from "../create/supportTicketReasonCategories";

export const extraSupportTagOptions = [
  { tag: "testy", label: "Testy" },
  { tag: "zle-zamowienie", label: "Złe zamówienie" },
  { tag: "blik", label: "BLIK" },
  { tag: "platnosc", label: "Płatność" },
  { tag: "zwrot", label: "Zwrot" },
  { tag: "reklamacja", label: "Reklamacja" },
  { tag: "dostawa", label: "Dostawa" },
  { tag: "brak-przesylki", label: "Brak przesyłki" },
  { tag: "blad-systemu", label: "Błąd systemu" },
  { tag: "integracja", label: "Integracja" },
  { tag: "faktura", label: "Faktura" },
  { tag: "anulowanie", label: "Anulowanie" },
  { tag: "vip", label: "VIP" },
  { tag: "pilne", label: "Pilne" },
];

const supportTagSuggestions = [...getAllSupportReasonTags(), ...extraSupportTagOptions.map((option) => option.tag)];

const normalizeTag = (value: string) => value.trim().toLowerCase();

const blockedSupportTags = new Set(["seed"]);

export function isBlockedSupportTag(tag: string) {
  return blockedSupportTags.has(normalizeTag(tag));
}

export function withoutBlockedSupportTags(tags: string[]) {
  return tags.filter((tag) => !isBlockedSupportTag(tag));
}

export function getKnownSupportTagKeys() {
  return new Set(supportTagSuggestions.map(normalizeTag));
}

export const getSupportTagOptions = (searchText: string, selectedTags: string[] = []) => {
  const normalizedSearch = normalizeTag(searchText);
  const selected = selectedTags.map(normalizeTag);
  const allTags = [...supportTagSuggestions, ...selected].filter(
    (tag, index, list) => list.indexOf(tag) === index,
  );

  return allTags
    .filter((tag) => !isBlockedSupportTag(tag))
    .filter((tag) => (normalizedSearch ? tag.includes(normalizedSearch) : true))
    .map((tag) => ({ label: `#${tag}`, value: tag }));
};
